import { useState } from 'react';

export function useTab<T extends string>(defaultTab: T) {
  const [tab, setTab] = useState<T>(defaultTab);
  return [tab, setTab] as const;
}
